import RoleForm from '../../RoleForm'
import useAddRoleHandler from '../../../effects/add-role'
import { heapEvent } from '@equipmentshare/heaper'

export type AddRoleModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function AddRoleModal( { onCancel, onSuccess }: AddRoleModalProps ) {
	const addRole = useAddRoleHandler()

	const handleSubmit = async( name: string, spendingLimit: string ) => {
		heapEvent( 'Inventory - Add Role Modal - Click - Submit', {} )
		const sl = spendingLimit === '' ? undefined : parseFloat( spendingLimit )
		await addRole( name, sl )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Role Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<RoleForm
			onCancel={handleCancel}
			onSuccess={onSuccess}
			onSubmit={handleSubmit}
		/>
	)
}
